import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SliderStandard from './Slider';
const ManualInputSlider = t0 => {
  const $ = _c(14);
  const {
    hideArrowsIfAllSlidesVisible: t1,
    imageArray,
    imageHeight,
    imageWidth,
    navType,
    slideIndex,
    updateImageArraySize,
    visibleSlides,
    variant
  } = t0;
  const hideArrowsIfAllSlidesVisible = t1 === undefined ? false : t1;
  const finalVisibleSlides = visibleSlides ? visibleSlides.content ? visibleSlides.content : visibleSlides : 0;
  const t2 = variant === "reviews-list";
  let t3;
  if ($[0] !== t2) {
    t3 = classNames({
      "[&_.slider-slide]:!min-h-[400px] [&_.slider-slide]:!h-full [&_.slider-slide]:max-[569px]:!min-h-[275px] [&_.slider-list]:max-[568px]:!overflow-y-scroll": t2
    });
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== finalVisibleSlides || $[3] !== hideArrowsIfAllSlidesVisible || $[4] !== imageArray || $[5] !== imageHeight || $[6] !== imageWidth || $[7] !== navType || $[8] !== slideIndex || $[9] !== updateImageArraySize) {
    t4 = <SliderStandard finalVisibleSlides={finalVisibleSlides} hideArrowsIfAllSlidesVisible={hideArrowsIfAllSlidesVisible} imageArray={imageArray} imageHeight={imageHeight} imageWidth={imageWidth} navType={navType} slideIndex={slideIndex} updateImageArraySize={updateImageArraySize} />;
    $[2] = finalVisibleSlides;
    $[3] = hideArrowsIfAllSlidesVisible;
    $[4] = imageArray;
    $[5] = imageHeight;
    $[6] = imageWidth;
    $[7] = navType;
    $[8] = slideIndex;
    $[9] = updateImageArraySize;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
ManualInputSlider.propTypes = {
  hideArrowsIfAllSlidesVisible: PropTypes.bool,
  imageArray: PropTypes.array,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  navType: PropTypes.string,
  slideIndex: PropTypes.number,
  updateImageArraySize: PropTypes.func,
  variant: PropTypes.oneOf(['reviews-list']),
  visibleSlides: PropTypes.object
};
export default ManualInputSlider;